import { h2Css, paragraphCss } from "@/styles/typography";
import { Link } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";
import styled from "styled-components";

const Container = styled.div<{
  isScrolled: boolean;
  isOpen: boolean;
  scrollDirection: string;
  offsetY: number;
  isHome: boolean;
}>`
  background-color: ${({ isHome, isScrolled }) =>
    isHome && !isScrolled ? "transparent" : "white"};
  z-index: 1000;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 210px;

  transition: height 0.5s ease-in-out, background-color 0.5s ease-in-out,
    transform 0.5s ease-in-out;

  ${({ isScrolled, isOpen }) =>
    isScrolled &&
    !isOpen &&
    `
    height: 100px;
  `}

  ${({ scrollDirection, isScrolled, offsetY, isOpen }) =>
    scrollDirection === "down" &&
    isScrolled &&
    offsetY > 100 &&
    !isOpen &&
    `
    transform: translateY(-100px);


  `}

  @media screen and (max-width: 680px) {
    background-color: white;
  }
`;

const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  height: 100%;
  padding-top: 20px;
  position: relative;
`;

const HeaderLine = styled.div<{ active: boolean }>`
  display: flex;
  height: 10px;
  background-color: ${({ theme, active }) =>
    active ? theme.colors.tango : "transparent"};

  ${({ active }) =>
    active &&
    `
  animation: grow 0.5s ease-in-out forwards;
`}

  @keyframes grow {
    0% {
      width: 0%;
    }
    100% {
      width: 100%;
    }
  }
`;

const HeaderLink = styled(Link)<{
  active?: boolean;
  isHome?: boolean;
  isScrolled?: boolean;
}>`
  ${paragraphCss}
  font-family: "Aeonik - Regular";

  color: ${({ theme, isHome, isScrolled }) =>
    isHome && !isScrolled ? theme.colors.white : theme.colors.softBlack};
  text-decoration: none;
  transition: all 0.2s ease-in-out;
  /* border-top: 10px solid
    ${({ active, theme }) => (active ? theme.colors.tango : "transparent")}; */
  padding-top: 9px;
  margin-top: -29px;
  width: fit-content;

  @media screen and (max-width: 820px) {
    display: none;
  }
`;

const LogoWrapper = styled.div<{ isScrolled: boolean }>`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  transition: all 0.5s ease-in-out;

  /* height: calc(100% - 20px); */
  aspect-ratio: 108 / 170;
  height: ${({ isScrolled }) => (isScrolled ? "80px" : "170px")};
  margin: 0 auto;
  z-index: 1000;
`;

const Logo = styled(GatsbyImage)<{
  isHome?: boolean;
  scrolled: boolean;
  isOpen: boolean;
}>`
  width: 100%;
  object-fit: cover;

  ${({ isHome, scrolled, isOpen }) =>
    isHome &&
    !scrolled &&
    !isOpen &&
    `
    filter: brightness(0) invert(1);

  `}
  @media screen and (max-width: 680px) {
    filter: none;
  }
`;

const LinksWrapper = styled.div`
  display: flex;
  gap: 30px;

  @media screen and (max-width: 820px) {
    display: none;
  }
`;

const Hamburger = styled.div<{ isOpen: boolean }>`
  position: absolute;
  top: 17px;
  right: 14px;
  z-index: 101;
  cursor: pointer;
  transition: color 0.1s ease-in-out;
  transform: ${({ isOpen }) =>
    isOpen ? "translateX(10px) " : "translateX(0)"};

  display: none;

  @media screen and (max-width: 820px) {
    display: block;
  }
  z-index: 10000;
`;

const HamburgerLine1 = styled.div<{
  isOpen: boolean;
  isHome: boolean;
  isScrolled: boolean;
}>`
  width: 24px;
  height: 2px;
  background-color: ${({ theme, isHome, isScrolled }) =>
    isHome && !isScrolled ? theme.colors.white : theme.colors.softBlack};
  margin-bottom: 5px;
  transform: ${({ isOpen }) =>
    isOpen ? "rotate(-45deg) translateX(-10px) " : "rotate(0) translateX(0)"};
  transition: transform 0.3s ease-in-out;

  @media screen and (max-width: 680px) {
    background-color: ${({ theme }) => theme.colors.softBlack};
  }
`;
const HamburgerLine2 = styled.div<{
  isOpen: boolean;
  isHome: boolean;
  isScrolled: boolean;
}>`
  width: 24px;
  height: 2px;
  background-color: ${({ theme, isHome, isScrolled }) =>
    isHome && !isScrolled ? theme.colors.white : theme.colors.softBlack};
  margin-bottom: 5px;
  transform: ${({ isOpen }) => (isOpen ? "translateX(60px)" : "translateX(0)")};
  opacity: ${({ isOpen }) => (isOpen ? "0" : "1")};
  transition: all 0.3s ease-in-out;
  @media screen and (max-width: 680px) {
    background-color: ${({ theme }) => theme.colors.softBlack};
  }
`;
const HamburgerLine3 = styled.div<{
  isOpen: boolean;
  isHome: boolean;
  isScrolled: boolean;
}>`
  width: 24px;
  height: 2px;
  background-color: ${({ theme, isHome, isScrolled }) =>
    isHome && !isScrolled ? theme.colors.white : theme.colors.softBlack};
  margin-bottom: 9px;
  transform: ${({ isOpen }) =>
    isOpen ? "rotate(45deg) translateX(-10px)" : "rotate(0) translateX(0)"};
  transition: transform 0.3s ease-in-out;
  @media screen and (max-width: 680px) {
    background-color: ${({ theme }) => theme.colors.softBlack};
  }
`;

const MobileMenu = styled.div<{ isOpen: boolean; isScrolled: boolean }>`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.colors.pearlBush};
  z-index: 100;
  display: flex;
  flex-direction: column;
  padding-top: 130px;
  padding-bottom: 30px;

  visibility: hidden;
  opacity: 0;
  transition: all 0.5s ease-in-out;

  overflow-y: scroll;

  ${({ isOpen }) =>
    isOpen &&
    `
    visibility: visible;
    opacity: 1;
  `};

  ${({ isScrolled }) =>
    isScrolled &&
    `


    `}
`;

const MobileLinksWrapper = styled.div<{ isOpen: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 5px;
  margin-top: 100px;
  margin-bottom: 30px;
  margin-left: 8px;
`;

const MobileLink = styled(Link)<{ isOpen: boolean }>`
  font-family: "Aeonik - Regular";
  font-style: normal;
  font-weight: 400;
  font-size: 55px;
  line-height: 66px;

  color: ${({ theme }) => theme.colors.softBlack};
  text-decoration: none;
  transition: all 0.2s ease-in-out;
  padding-top: 3px;
  margin-top: 0;
  opacity: 0;

  ${({ isOpen }) =>
    isOpen &&
    `
  animation: animateIn 0.5s ease-in-out forwards;
`}

  &:nth-of-type(1) {
    animation-delay: 0.2s;
  }
  &:nth-of-type(2) {
    animation-delay: 0.3s;
  }
  &:nth-of-type(3) {
    animation-delay: 0.4s;
  }
  &:nth-of-type(4) {
    animation-delay: 0.5s;
  }

  @keyframes animateIn {
    0% {
      opacity: 0;
      transform: translateY(20px);
    }
    100% {
      opacity: 1;
      transform: translateX(0);
    }
  }
`;

const SocialLinkWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
  margin-left: 8px;
`;

const SocialLink = styled.a<{ isOpen: boolean }>`
  font-family: "Aeonik - Regular";

  font-style: normal;
  font-size: 30px;
  text-decoration: none;
  color: ${({ theme }) => theme.colors.softBlack};
  opacity: 0;

  :last-of-type {
    padding-bottom: 30px;
  }

  ${({ isOpen }) =>
    isOpen &&
    `
  animation: animateIn 0.5s ease-in-out forwards;
`}

  &:nth-of-type(1) {
    animation-delay: 0.2s;
  }
  &:nth-of-type(2) {
    animation-delay: 0.3s;
  }
  &:nth-of-type(3) {
    animation-delay: 0.4s;
  }
  &:nth-of-type(4) {
    animation-delay: 0.5s;
  }

  @keyframes animateIn {
    0% {
      opacity: 0;
      transform: translateY(20px);
    }
    100% {
      opacity: 1;
      transform: translateX(0);
    }
  }
`;

const S = {
  Container,
  HeaderWrapper,
  HeaderLine,
  HeaderLink,
  LogoWrapper,
  Logo,
  LinksWrapper,
  Hamburger,
  HamburgerLine1,
  HamburgerLine2,
  HamburgerLine3,
  MobileMenu,
  MobileLinksWrapper,
  MobileLink,
  SocialLinkWrapper,
  SocialLink,
};

export default S;
